// Undo / redo stack with a leading-edge throttle on add().
//
// add() is throttled so a burst of typing collapses into one history
// entry; the first call within each window is recorded and subsequent
// calls are dropped until the window expires. forceAdd() bypasses the
// throttle — used at IME compositionend so a long composition doesn't
// get swallowed by a recently-fired typing burst.

export class History {
  static saveInterval = 1000

  constructor(maxSize = 500) {
    this.maxSize = maxSize
    this.undoStack = []
    this.redoStack = []
    this.throttle = null
  }

  add = (snapshot) => {
    if (this.throttle) return
    this.push(snapshot)
    this.throttle = setTimeout(() => {
      this.throttle = null
    }, History.saveInterval)
  }

  forceAdd(snapshot) {
    this.resetThrottle()
    this.add(snapshot)
  }

  resetThrottle() {
    if (!this.throttle) return
    clearTimeout(this.throttle)
    this.throttle = null
  }

  undo(currentSnapshot) {
    const previous = this.undoStack.pop()
    if (!previous) return {}
    this.redoStack.push(currentSnapshot)
    return previous
  }

  redo(currentSnapshot) {
    const next = this.redoStack.pop()
    if (!next) return {}
    this.undoStack.push(currentSnapshot)
    return next
  }

  push(snapshot) {
    this.undoStack.push(snapshot)
    this.redoStack = []
    if (this.undoStack.length > this.maxSize) this.undoStack.shift()
  }
}
